import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import skyeairLogo from "../../../assets/images/skyeairLogoSvg.svg";
import skyeairBlueLogo from "../../../assets/icons/skyeairBlue.svg";
import homeIcon from "../../../assets/icons/home.svg";
import hoverIcon from "../../../assets/icons/logistics.svg";
import Popup from "../confirmPopup/Popup"; // Adjust path if needed
import "./header.css"; // Optional
import { useLocation } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from 'react-redux';
import { FormHelperText } from "@mui/material";

const Header = () => {
    const baseURL = process.env.REACT_APP_BASE_URL;

    const [showModal, setShowModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        Name: "",
        LastName: "",
        Company: "",
        Email: "",
        Phone: "",
        Message: "",
        Enquiry: "",
    });

    const [enquiryDropdown, setEnquiryDropdown] = useState([]);
    const data = useSelector((store) => store.data.HomeData);

    useEffect(() => {
        data?.items.forEach((ele) => {
            if (ele.Section == "GeneralQuery") {
                setEnquiryDropdown(ele.Queries);
            }
        });
    }, [data]);

    const handleOpen = () => setShowModal(true);

    const handleClose = () => {
        setShowModal(false);
        setFormData({
            Name: "",
            LastName: "",
            Company: "",
            Email: "",
            Phone: "",
            Message: "",
            Enquiry: "",
        });
        setErrors({});
    };

    const handlesuccess = () => setShowSuccessModal(!showSuccessModal);

    const validate = () => {
        const newErrors = {};
        if (!formData.Name.trim()) {
            newErrors.Name = "First name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.Name)) {
            newErrors.Name = "First name must contain only letters";
        }
        if (!formData.LastName.trim()) {
            newErrors.LastName = "Last name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.LastName)) {
            newErrors.LastName = "Last name must contain only letters";
        }
        if (!formData.Email.trim()) {
            newErrors.Email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.Email)) {
            newErrors.Email = "Email is invalid";
        }
        if (!formData.Phone.trim()) {
            newErrors.Phone = "Phone number is required";
        } else if (!/^\d{10}$/.test(formData.Phone)) {
            newErrors.Phone = "Phone number must be 10 digits";
        }
        if (!formData.Message.trim()) {
            newErrors.Message = "Message is required";
        }
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        const error = validateField(name, value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        setIsSubmitting(true);
        const formDataJSON = JSON.stringify(formData);
        try {
            const response = await fetch(
                `${baseURL}/main-website/post-contact-form`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: formDataJSON,
                }
            );

            if (response.ok) {
                handleClose();
                handlesuccess();
            } else {
                alert("Failed to submit the form.");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };
    const location = useLocation();
    const isContactPage = location.pathname.includes('/contact');
    const isHomeRoute = location.pathname.includes('home');
    const isUTMRoute = location.pathname.includes('utm-contact');
    useEffect(() => {
        if (showModal) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
    }, [showModal]);

    const validateField = (name, value) => {
        switch (name) {
            case "Name":
                if (!value.trim()) return "First name is required";
                if (!/^[A-Za-z\s]+$/.test(value)) return "First name must contain only letters";
                break;
            case "LastName":
                if (!value.trim()) return "Last name is required";
                if (!/^[A-Za-z\s]+$/.test(value)) return "Last name must contain only letters";
                break;
            case "Email":
                if (!value.trim()) return "Email is required";
                if (!/\S+@\S+\.\S+/.test(value)) return "Email is invalid";
                break;
            case "Phone":
                if (!value.trim()) return "Phone number is required";
                if (!/^\d{10}$/.test(value)) return "Phone number must be 10 digits";
                break;
            case "Message":
                if (!value.trim()) return "Message is required";
                break;
            default:
                return null;
        }
        return null; // No error
    };

    return (
        <>
            <div className="home-header">
                <Link to="/home" className="p-left">
                    {isContactPage || isHomeRoute  ?
                        <img src={skyeairBlueLogo} alt="Skye Air Logo" className="header-logo" />
                        :
                        <img src={skyeairLogo} alt="Skye Air Logo" className="header-logo" />
                    }
                </Link>
               { !isUTMRoute && <div className="about-us p-right" onClick={handleOpen}>
                    <span className="delivery-icon-wrapper">
                        {/* <img src={homeIcon} alt="Icon" className="delivery-icon default-icon" height={20} /> */}
                        <img src={hoverIcon} alt="Hover Icon" className="delivery-icon hover-icon" height={20} />
                    </span>
                    <span className="delivery-text">Deliver with us Today</span>
                </div>
                }
            </div>

            {/* Modal */}
            {showModal && (
                <div className="modal show fade d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered modal-80w contact-modal " role="document">
                        <form onSubmit={handleSubmit}>
                            <div className={`modal-content  ${isHomeRoute ? '' : 'white-bg'}` }>
                                <div className="modal-body">
                                    <h2 className="text-center fw-bold capitalize-first-letter">Delivery with us</h2>
                                    <p className="text-desc">
                                        If you're looking to be part of a company transforming lives,
                                        explore our drone logistics platform.
                                    </p>
                                    <div className="row">
                                        <div className="col-md-6 mb-3 mt-3">
                                            <TextField
                                                name="Name"
                                                label={
                                                    <>
                                                      First Name <span style={{ color: 'red' }}>*</span>
                                                    </>
                                                }
                                                variant="standard"
                                                fullWidth
                                                value={formData.Name}
                                                onChange={handleChange}
                                                error={!!errors.Name}
                                                helperText={errors.Name}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3 mt-3">
                                            <TextField
                                                name="LastName"
                                                label={
                                                    <>
                                                      Last Name <span style={{ color: 'red' }}>*</span>
                                                    </>
                                                }
                                                variant="standard"
                                                fullWidth
                                                value={formData.LastName}
                                                onChange={handleChange}
                                                error={!!errors.LastName}
                                                helperText={errors.LastName}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3 mt-3">
                                            <TextField
                                                name="Email"
                                                label={
                                                    <>
                                                     Email ID <span style={{ color: 'red' }}>*</span>
                                                    </>
                                                }
                                                variant="standard"
                                                fullWidth
                                                value={formData.Email}
                                                onChange={handleChange}
                                                error={!!errors.Email}
                                                helperText={errors.Email}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3 mt-3">
                                            <TextField
                                                name="Phone"
                                                label={
                                                    <>
                                                      Phone Number <span style={{ color: 'red' }}>*</span>
                                                    </>
                                                  }
                                                variant="standard"
                                                fullWidth
                                                value={formData.Phone}
                                                onChange={handleChange}
                                                error={!!errors.Phone}
                                                helperText={errors.Phone}
                                                inputProps={{ maxLength: 10 }}
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="row">
                                        <div className="col-md-6 mb-3 mt-3">
                                            <TextField
                                                name="Company"
                                                label="Organization"
                                                variant="standard"
                                                fullWidth
                                                value={formData.Company}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3 mt-3">
                                            <FormControl variant="standard" fullWidth error={!!errors.Enquiry}>
                                                <InputLabel id="message-label">Select Enquiry Type</InputLabel>
                                                <Select
                                                    labelId="message-label"
                                                    name="Enquiry"
                                                    value={formData.Enquiry}
                                                    onChange={handleChange}
                                                >
                                                    {enquiryDropdown?.map((option, index) => (
                                                        <MenuItem key={index} value={option}>
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText>{errors.Enquiry}</FormHelperText>
                                            </FormControl>
                                        </div>
                                    </div> */}

                                    <div className="row">
                                        <div className="mb-3 mt-3">
                                            <TextField
                                                name="Message"
                                                label={
                                                    <>
                                                     Message <span style={{ color: 'red' }}>*</span>
                                                    </>
                                                  }
                                                variant="standard"
                                                fullWidth
                                                value={formData.Message}
                                                onChange={handleChange}
                                                error={!!errors.Message}
                                                helperText={errors.Message}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                        {isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Modal backdrop */}
            {showModal && <div className="modal-backdrop fade show"></div>}
            {showSuccessModal && <Popup onClose={handlesuccess} />}
        </>
    );
};

export default Header;
